import { render } from "./LoadingView.vue?vue&type=template&id=50a1315c"
import script from "./LoadingView.vue?vue&type=script&lang=js"
export * from "./LoadingView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"LoadingView.vue"]])

export default __exports__